import { resolveBookingDateTime } from './resolveBookingDateTime';

// Adapt the grouped API response to the existing saved-slot format. The marker
// keeps the business date used by availability checks separate from the date
// shown to customers for appointments after midnight.
export const normalizeBookingSlots = (date, entries) => {
  const groups = { sameDay: [], nextDay: [] };
  const seen = new Set();
  const addSlot = (value, nextDay = false) => {
    if (typeof value !== 'string') return;
    let slot = resolveBookingDateTime(date, value);
    if (nextDay && !slot.isNextDay) {
      slot = resolveBookingDateTime(date, `${value} 🌙`);
    }
    if (!slot.date || !slot.time || seen.has(slot.slotLabel)) return;
    seen.add(slot.slotLabel);
    groups[slot.isNextDay ? 'nextDay' : 'sameDay'].push(slot);
  };

  if (!Array.isArray(entries)) return groups;
  entries.forEach((entry) => {
    if (typeof entry === 'string') {
      addSlot(entry);
      return;
    }
    if (!entry || typeof entry !== 'object') return;
    if (Array.isArray(entry.group_slot_same_day)) {
      entry.group_slot_same_day.forEach((slot) => addSlot(slot));
    }
    if (Array.isArray(entry.group_slot_next_day)) {
      entry.group_slot_next_day.forEach((slot) => addSlot(slot, true));
    }
  });
  return groups;
};
